// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CompanyCustomerCodeService = {};

CompanyCustomerCodeService.getCompanyCustomerCodeList = function (userInput) {
  return lossClient({
    url: "/customercompany/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default CompanyCustomerCodeService;
